"use client";

import { c as _c } from "react/compiler-runtime";
import { IconSortArrowUpDown } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import { IconPaperPlane2Outline18 } from "nucleo-ui-outline-18";
import { CheckBox } from "@/components/ui/CheckBox";
import { TokenWithChainIcon } from "@/components/ui/token-with-chain-icon";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { SimBalanceItem } from "@/hooks/useSimTokenInfo";
import { PixelLoader } from "@/components/ui/pixel-loader";
import { isNativeTokenAddress } from "@/lib/tokens/nativeToken";
import { formatUsdValue } from "@/lib/utils";
import { TokenHoverTooltip } from "./TokenHoverTooltip";
export function tokenKey(balance: SimBalanceItem): string {
  return `${balance.chain_id}-${balance.address}`;
}
interface WalletTokenBalanceRowProps {
  balance: SimBalanceItem;
  chainInfo?: {
    name?: string;
    iconUrl?: string | null;
    explorers?: Array<{
      url: string;
    }>;
  };
  humanBalance: string;
  showTransferButton?: boolean;
  onTransferClick?: (balance: SimBalanceItem, humanBalance: string) => void;
  showSwapButton?: boolean;
  onSwapClick?: (balance: SimBalanceItem, humanBalance: string) => void;
  swapDisabled?: boolean;
  swapDisabledReason?: string;
  selectable?: boolean;
  isSelected?: boolean;
  onSelectChange?: (balance: SimBalanceItem, selected: boolean) => void;
  transferDisabled?: boolean;
  transferDisabledReason?: string;
}
export function WalletTokenBalanceRow(t0) {
  const $ = _c(68);
  const {
    balance,
    chainInfo,
    humanBalance,
    showTransferButton: t1,
    onTransferClick,
    showSwapButton: t2,
    onSwapClick,
    swapDisabled: t3,
    swapDisabledReason,
    selectable: t4,
    isSelected: t5,
    onSelectChange,
    transferDisabled: t6,
    transferDisabledReason
  } = t0;
  const showTransferButton = t1 === undefined ? false : t1;
  const showSwapButton = t2 === undefined ? false : t2;
  const swapDisabled = t3 === undefined ? false : t3;
  const selectable = t4 === undefined ? false : t4;
  const isSelected = t5 === undefined ? false : t5;
  const transferDisabled = t6 === undefined ? false : t6;
  const t7 = parseFloat(humanBalance);
  let t8;
  if ($[0] !== t7) {
    t8 = t7.toLocaleString(undefined, {
      maximumFractionDigits: 6
    });
    $[0] = t7;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const formattedBalance = t8;
  let t9;
  if ($[2] !== balance.value_usd) {
    t9 = formatUsdValue(balance.value_usd);
    $[2] = balance.value_usd;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const formattedUsd = t9;
  let t10;
  if ($[4] !== balance.symbol) {
    t10 = <span className="font-semibold text-zinc-950 dark:text-white">{balance.symbol}</span>;
    $[4] = balance.symbol;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== chainInfo) {
    t11 = chainInfo?.name ? <span className="text-ds-text-muted font-normal">on {chainInfo.name}</span> : null;
    $[6] = chainInfo;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== t10 || $[9] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  const title = t12;
  let t13;
  if ($[11] !== balance || $[12] !== isSelected || $[13] !== onSelectChange || $[14] !== selectable) {
    t13 = selectable && <CheckBox checked={isSelected} onChange={checked => onSelectChange?.(balance, checked)} size="sm" className={isSelected ? "" : "opacity-0 transition-opacity duration-150 group-hover/token:opacity-100"} />;
    $[11] = balance;
    $[12] = isSelected;
    $[13] = onSelectChange;
    $[14] = selectable;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = balance.token_metadata?.logo;
  const t15 = chainInfo?.iconUrl;
  const t16 = chainInfo?.name;
  let t17;
  if ($[16] !== balance.address || $[17] !== balance.chain_id || $[18] !== balance.symbol || $[19] !== t14 || $[20] !== t15 || $[21] !== t16) {
    t17 = <TooltipTrigger asChild={true}><div><TokenWithChainIcon logoUrl={t14} chainId={balance.chain_id} tokenAddress={balance.address} symbol={balance.symbol} tokenSize={36} chainIconUrl={t15} chainName={t16} chainIconSize={16} /></div></TooltipTrigger>;
    $[16] = balance.address;
    $[17] = balance.chain_id;
    $[18] = balance.symbol;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== chainInfo) {
    t18 = chainInfo?.name ? <TooltipContent>{chainInfo.name}</TooltipContent> : null;
    $[23] = chainInfo;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t17 || $[26] !== t18) {
    t19 = <TooltipProvider><Tooltip>{t17}{t18}</Tooltip></TooltipProvider>;
    $[25] = t17;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== balance.address || $[29] !== chainInfo || $[30] !== title) {
    t20 = <div className="flex flex-wrap items-baseline gap-x-1.5 text-sm leading-tight">{!isNativeTokenAddress(balance.address) && chainInfo?.explorers?.[0] ? <a href={`${chainInfo.explorers[0].url}/token/${balance.address}`} target="_blank" rel="noopener noreferrer" className="inline-flex flex-wrap items-baseline gap-x-1.5 text-sm hover:underline">{title}</a> : <div className="inline-flex flex-wrap items-baseline gap-x-2">{title}</div>}</div>;
    $[28] = balance.address;
    $[29] = chainInfo;
    $[30] = title;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== formattedUsd) {
    t21 = formattedUsd ? <span className="text-ds-text-muted"> ({formattedUsd})</span> : null;
    $[32] = formattedUsd;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== balance.symbol || $[35] !== formattedBalance || $[36] !== t21) {
    t22 = <div className="label label-xs mt-1">{formattedBalance} {balance.symbol}{t21}</div>;
    $[34] = balance.symbol;
    $[35] = formattedBalance;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t20 || $[39] !== t22) {
    t23 = <div className="min-w-0">{t20}{t22}</div>;
    $[38] = t20;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== balance || $[42] !== t23) {
    t24 = <TokenHoverTooltip token={balance}>{t23}</TokenHoverTooltip>;
    $[41] = balance;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t13 || $[45] !== t19 || $[46] !== t24) {
    t25 = <div className="flex min-w-0 items-center gap-4">{t13}{t19}{t24}</div>;
    $[44] = t13;
    $[45] = t19;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== balance || $[49] !== humanBalance || $[50] !== onSwapClick || $[51] !== showSwapButton || $[52] !== swapDisabled || $[53] !== swapDisabledReason) {
    t26 = showSwapButton && onSwapClick ? swapDisabled ? <TooltipProvider><Tooltip><TooltipTrigger asChild={true}><span role="button" tabIndex={0} aria-disabled="true" className="label label-xs inline-flex cursor-not-allowed items-center gap-1 text-zinc-400 opacity-0 transition-all duration-150 focus-visible:opacity-100 group-hover/token:opacity-70 dark:text-zinc-500">Swap<IconSortArrowUpDown className="h-3.5 w-3.5" /></span></TooltipTrigger>{swapDisabledReason ? <TooltipContent>{swapDisabledReason}</TooltipContent> : null}</Tooltip></TooltipProvider> : <button type="button" onClick={() => onSwapClick(balance, humanBalance)} className="label label-xs inline-flex items-center gap-1 opacity-0 transition-all duration-150 hover:text-blue-600 focus:opacity-100 focus-visible:opacity-100 group-hover/token:opacity-100 dark:hover:text-blue-400">Swap<IconSortArrowUpDown className="h-3.5 w-3.5" /></button> : null;
    $[48] = balance;
    $[49] = humanBalance;
    $[50] = onSwapClick;
    $[51] = showSwapButton;
    $[52] = swapDisabled;
    $[53] = swapDisabledReason;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== balance || $[56] !== humanBalance || $[57] !== onTransferClick || $[58] !== showTransferButton || $[59] !== transferDisabled || $[60] !== transferDisabledReason) {
    t27 = showTransferButton && onTransferClick ? transferDisabled ? <TooltipProvider><Tooltip><TooltipTrigger asChild={true}><span role="button" tabIndex={0} aria-disabled="true" className="label label-xs text-ds-text-disabled dark:text-ds-text-muted inline-flex cursor-not-allowed items-center gap-1 opacity-0 transition-all duration-150 focus-visible:opacity-100 group-hover/token:opacity-70">Send<IconPaperPlane2Outline18 className="h-3.5 w-3.5" /></span></TooltipTrigger>{transferDisabledReason ? <TooltipContent>{transferDisabledReason}</TooltipContent> : null}</Tooltip></TooltipProvider> : <button type="button" onClick={() => onTransferClick(balance, humanBalance)} className="label label-xs inline-flex items-center gap-1 opacity-0 transition-all duration-150 hover:text-blue-600 focus:opacity-100 focus-visible:opacity-100 group-hover/token:opacity-100 dark:hover:text-blue-400">Send<IconPaperPlane2Outline18 className="h-3.5 w-3.5" /></button> : null;
    $[55] = balance;
    $[56] = humanBalance;
    $[57] = onTransferClick;
    $[58] = showTransferButton;
    $[59] = transferDisabled;
    $[60] = transferDisabledReason;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t26 || $[63] !== t27) {
    t28 = <div className="flex shrink-0 items-center gap-6">{t26}{t27}</div>;
    $[62] = t26;
    $[63] = t27;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t25 || $[66] !== t28) {
    t29 = <div className="group/token flex items-center justify-between gap-4 px-4 py-3 pr-8">{t25}{t28}</div>;
    $[65] = t25;
    $[66] = t28;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  return t29;
}